<template>
  <v-container class="page-content-wrapper pa-0 px-sm-3">
    <h1 class="headline pa-3 pa-sm-4">{{ $t("welcome") }} {{ user.name }}</h1>
    <template v-if="currentHotel">
      <metrics-filters
        @update:filters="getMetricsData($event)"
        @refresh-data="getMetricsData(filters)"
      ></metrics-filters>
      <v-sheet color="transparent" width="1200" max-width="100%">
        <v-row class="ma-0">
          <v-col cols="12" sm="6" md="7" lg="5">
            <amounts-metrics
              :amount-metrics="amountMetrics"
              :loading="loadingData"
            ></amounts-metrics>
          </v-col>
          <v-col cols="12" sm="6" md="5" lg="4">
            <payment-methods-totals-chart
              :loading="loadingData"
              :chart-data="paymentMethodsTotalsData"
            ></payment-methods-totals-chart>
          </v-col>
          <v-col v-if="!$vuetify.breakpoint.md" cols="12" lg="3">
            <pay-link-metrics
              :paylink-items="paylinkItems"
              :loading="loadingData"
            ></pay-link-metrics>
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col v-if="$vuetify.breakpoint.md" cols="12" md="4">
            <pay-link-metrics
              :paylink-items="paylinkItems"
              :loading="loadingData"
            ></pay-link-metrics>
          </v-col>
          <v-col cols="12" md="8" lg="12">
            <captured-transactions-chart
              :loading="loadingData"
              :chart-items="capturedTransactions"
            >
            </captured-transactions-chart>
          </v-col>
        </v-row>
      </v-sheet>
    </template>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { axiosGet } from "@/api/requests";
import handleErrorStatus from "@/mixins/handleErrorStatus";
import snackBarMessages from "@/mixins/snackBarMessages";
import MetricsFilters from "@/components/metrics/MetricsFilters";
import CapturedTransactionsChart from "@/components/metrics/CapturedTransactionsChart";
import AmountsMetrics from "@/components/metrics/AmountsMetrics";
import PayLinkMetrics from "@/components/metrics/PayLinkMetrics";
import PaymentMethodsTotalsChart from "@/components/metrics/PaymentMethodsTotalsChart";
import { amountMetrics } from "@/static/staticData";

export default {
  title: "dashboard",
  name: "Dashboard",
  paymentTypes: [],
  components: {
    MetricsFilters,
    AmountsMetrics,
    PayLinkMetrics,
    CapturedTransactionsChart,
    PaymentMethodsTotalsChart,
  },
  mixins: [snackBarMessages, handleErrorStatus],
  data() {
    return {
      loadingData: true,
      filters: null,
      paymentMethodsTotalsData: [],
      capturedTransactions: [],
      amountMetrics: [],
      paylinkItems: [],
    };
  },
  computed: {
    ...mapState(["user", "currentHotel", "connection"]),
  },
  mounted() {
    if (
      !this.currentHotel &&
      ([3, 4, 5, 6, 10].includes(this.user.accessType) ||
        ([1, 2, 12].includes(this.user.accessType) &&
          this.user.hotels.trim().split(";").length > 1))
    ) {
      this.$emit("show-hotel-selector");
    }
  },
  methods: {
    getMetricsData(filters) {
      this.loadingData = true;
      const url =
        process.env.VUE_APP_DATA_URL +
        "/opi/dashboard?name=" +
        this.connection.code +
        "&hotelCode=" +
        this.currentHotel.hotelCode +
        "&period=" +
        filters.period;
      axiosGet(url, this.user.authToken)
        .then((response) => {
          this.handleGetMetricsDataResponse(response, filters);
        })
        .catch((error) => {
          console.log(error);
          this.snackbarError(this.$t("loadingDataFailed"));
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
    handleGetMetricsDataResponse(response, filters) {
      if (response.status && response.status !== 200) {
        this.handleErrorStatus(response.status);
      } else if (response.success) {
        const amountMetricsData = amountMetrics;
        amountMetricsData.forEach((item) => {
          const dasboardCard = response.dashboard.cards.find(
            (cardData) => cardData.cardType === item.id
          );
          if (dasboardCard) {
            item.items = dasboardCard.items;
          }
        });
        this.amountMetrics = amountMetricsData;
        const paylinkMetricsData = response.dashboard.cards.find(
          (cardData) => cardData.cardType === 5
        );
        if (paylinkMetricsData) {
          this.paylinkItems = paylinkMetricsData.items;
        }

        const paymentMethodsTotalsData = response.dashboard.cards.find(
          (cardData) => cardData.cardType === 6
        );
        if (paymentMethodsTotalsData) {
          this.paymentMethodsTotalsData = paymentMethodsTotalsData.items;
        }
        this.capturedTransactions = response.dashboard.transactions;
        this.filters = filters;
      } else {
        this.snackbarError(this.$t("loadingDataFailed"));
      }
    },
  },
};
</script>
